import { PLAN_STEPS } from 'modules/estatePlan/constants/constants';
import { find } from 'lodash';

export default function getNextPlanStep(currentStepNo: number): PlanStep {
  return (
    find(PLAN_STEPS, (step) => step.stepNo === currentStepNo + 1) ||
    ({} as PlanStep)
  );
}
